import { DateOnly } from "./types/date-time-types";

const RE_ISO_DATE = /^(\d{4}-\d{2}-\d{2})/;

/**
 * @param dateStringWithTime can be of two formats: "2022-03-09 08:00" or ISO8601 (with "T")
 * @returns a Date object for the local timezone
 */
export function toDateOnly(dateStringWithTime: string): DateOnly {
  const match = dateStringWithTime.match(RE_ISO_DATE);
  if (!match) {
    throw new TypeError("This function assumes a string starting with yyyy-MM-DD");
  }
  const secondMatch = match[1];
  return secondMatch as DateOnly;
}

// "2021-10-30T08:20Z" -> "08:20"
export const extractTimeFromDateString = (dateString: string) =>
  dateString.split("T")[1].replace("Z", ""); // bugs waiting to happen
